import { defaultsConfig } from "~config/sport/defaults";
import { Roles } from "~enums/roles";
import { RosterPosition } from "~enums/rosterPosition";
import type { SportConfiguration } from "~types/sportConfiguration";

const seasonOfficialRoles: Array<Roles> = [
  Roles.CrewChief,
  Roles.Groundskeeper,
  Roles.Referee,
  Roles.RefereeAssistant,
  Roles.RefereeAssistantReserve,
  Roles.RefereeReserve,
  Roles.Scorer,
  Roles.ScorerAssistant,
  Roles.ShotClockOperator,
  Roles.Statistician,
  Roles.Timer,
  Roles.Umpire,
  Roles.Umpire1,
  Roles.Umpire2,
  Roles.Commissioner,
  Roles.Committee,
  Roles.General,
  Roles.President,
  Roles.PresidentVice,
  Roles.Treasurer,
];

const fixtureOfficialRoles: Array<Roles> = [...seasonOfficialRoles];

const rosterPositions = [RosterPosition.Goalie, RosterPosition.Skater];

export const ice3Config: SportConfiguration = {
  ...defaultsConfig,
  seasonOfficialRoles,
  fixtureOfficialRoles,
  rosterPositions,
};
